var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrossMargin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Global-/-Icons-/-Metrics-/-Gross-Margin-Up",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Global-/-Metric"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#E8F9ED",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Global-/-Gross-Margin",
    transform: "translate(10.000000, 10.000000)",
    fill: "#39C258"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,14 L16,14 L16,2 L14,2 L14,14 Z M12,-7.10542736e-15 L14,-7.10542736e-15 L16,-7.10542736e-15 L18,-7.10542736e-15 L18,2 L18,14 L18,16 L16,16 L14,16 L12,16 L12,14 L12,2 L12,-7.10542736e-15 Z M4,14 L6,14 L6,2 L4,2 L4,14 Z M8,14 L8,16 L6,16 L4,16 L2,16 L2,14 L2,2 L2,-1.0658141e-14 L4,-1.0658141e-14 L6,-1.0658141e-14 L8,-1.0658141e-14 L8,2 L8,14 Z M0,20 L20,20 L20,18 L0,18 L0,20 Z",
    id: "Gross-Margin"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrossMargin);
export default __webpack_public_path__ + "static/media/gross-margin.d9bb4c96.svg";
export { ForwardRef as ReactComponent };